import { Predicate } from 'effect';

/**
 * The value one call asked for, as the error message and the span attribute
 * report it — a taxon code, a product slug, a cart token, a listing page number.
 *
 * An endpoint that takes no parameters has nothing to name, so a call may omit
 * it.
 */
export type ApiRequestIdentifier = string | number;

/**
 * The identifier as a span attribute and an error payload field, under the name
 * the operation's error family already uses for it.
 *
 * A call with no identifier contributes neither, rather than an `undefined`
 * attribute. Shared by the read template and the write templates so the three
 * cannot disagree about what a span carries.
 */
export const identifierFields = (
  field: string,
  identifier: ApiRequestIdentifier | undefined
): Record<string, ApiRequestIdentifier> =>
  Predicate.isUndefined(identifier) ? {} : { [field]: identifier };
